var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAntDesignBackwardOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 30,
    viewBox: "0 0 58 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5047 7.32132L11.2262 14.5899C10.7561 14.7979 10.7561 15.1992 11.2262 15.4073L27.5047 22.6787C28.1108 22.9483 29 22.7051 29 22.2686V7.72854C29 7.29495 28.1108 7.04885 27.5047 7.32132ZM45.6297 7.32132L29.3512 14.5899C29.2397 14.6414 29.1508 14.7047 29.0902 14.7754C29.0297 14.8461 28.9989 14.9227 29 15C29 15.1524 29.119 15.3047 29.3512 15.4102L45.6297 22.6817C46.2358 22.9512 47.125 22.708 47.125 22.2715V7.72854C47.125 7.29495 46.2358 7.04885 45.6297 7.32132Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAntDesignBackwardOutlined);
export default __webpack_public_path__ + "static/media/ant-design_backward-outlined.d1ccee83011d168053f1ee0471ee9804.svg";
export { ForwardRef as ReactComponent };